import graphql__8e07e1540f64ecf1f89a from "./__generated__/ProfileContributionsRouteQuery.graphql.js";import { graphql } from "react-relay";
import AppQueryRenderer from "../AppQueryRenderer";

import ProfileContributions from "../Profile/ProfileContributions";

const ProfileContributionsRoute = props => {
  return (
    <AppQueryRenderer
      query={ProfileContributionsRouteQuery}
      component={ProfileContributions}
      additionalProps={props}
      fetchPolicy="network-only"
    />
  );
};

const ProfileContributionsRouteQuery = graphql__8e07e1540f64ecf1f89a;

export default ProfileContributionsRoute;
